export { default } from "ember-stereo/-private/utils/shared-audio-access";
